const OPEN_DELETE_DECISION_STRATEGY_MODULE_WIZARD = 'OPEN_DELETE_DECISION_STRATEGY_MODULE_WIZARD';
const CLOSE_DELETE_DECISION_STRATEGY_MODULE_WIZARD = 'CLOSE_DELETE_DECISION_STRATEGY_MODULE_WIZARD';

export { OPEN_DELETE_DECISION_STRATEGY_MODULE_WIZARD, CLOSE_DELETE_DECISION_STRATEGY_MODULE_WIZARD };
